import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import { useTheme } from 'vuetify'

export const useThemeStore = defineStore('theme', () => {
  const isDark = ref(false)
  let vuetifyTheme: ReturnType<typeof useTheme> | null = null

  // Initialize theme from localStorage
  const initTheme = () => {
    const savedTheme = localStorage.getItem('theme')
    if (savedTheme) {
      isDark.value = savedTheme === 'dark'
    } else {
      // Default to light mode
      isDark.value = false
    }
    applyTheme()
  }

  const applyTheme = () => {
    // Apply CSS class for custom styles
    if (isDark.value) {
      document.documentElement.classList.add('dark-mode')
    } else {
      document.documentElement.classList.remove('dark-mode')
    }

    // Sync with Vuetify theme
    if (!vuetifyTheme) {
      try {
        vuetifyTheme = useTheme()
      } catch (e) {
        // Theme not yet available, will sync on next call
        return
      }
    }

    if (vuetifyTheme) {
      vuetifyTheme.global.name.value = isDark.value ? 'ApSimDark' : 'ApSimLight'
    }
  }

  const toggleTheme = () => {
    isDark.value = !isDark.value
    localStorage.setItem('theme', isDark.value ? 'dark' : 'light')
    applyTheme()
  }

  // Watch for theme changes
  watch(isDark, () => {
    applyTheme()
  })

  return {
    isDark,
    initTheme,
    toggleTheme
  }
})
